let persistentImage: HTMLImageElement | null = null;
let imageReady = false;

export const initSvgCapture = (): void => {
  persistentImage = new Image();
  imageReady = false;
};

export const updateSvgCapture = (): void => {
  if (!persistentImage) {
    return;
  }

  const svgEl = document.querySelector<SVGSVGElement>(".SVGLayer svg");
  if (!svgEl) {
    return;
  }

  const clone = svgEl.cloneNode(true) as SVGSVGElement;
  clone.setAttribute("width", String(window.innerWidth));
  clone.setAttribute("height", String(window.innerHeight));
  if (!clone.getAttribute("xmlns")) {
    clone.setAttribute("xmlns", "http://www.w3.org/2000/svg");
  }

  const serializer = new XMLSerializer();
  const svgString = serializer.serializeToString(clone);
  const dataUrl = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(
    svgString,
  )}`;

  imageReady = false;
  persistentImage.onload = () => {
    imageReady = true;
  };
  persistentImage.src = dataUrl;
};

export const drawSvgLayer = (
  ctx: CanvasRenderingContext2D,
  width: number,
  height: number,
): void => {
  if (persistentImage && imageReady) {
    ctx.drawImage(persistentImage, 0, 0, width, height);
  }
};

export const cleanupSvgCapture = (): void => {
  if (persistentImage) {
    persistentImage.onload = null;
    persistentImage.src = "";
    persistentImage = null;
  }
  imageReady = false;
};
